<script lang="ts">
	let className = '';
	export let odd = false;
	export { className as class };
</script>

<tr class={className} class:odd>
	<slot />
</tr>

<style>
	.odd {
		border-radius: 6px;
		background: var(--bg, #151516);
	}

	:global(.odd td:first-child) {
		border-top-left-radius: 6px;
		border-bottom-left-radius: 6px;
	}
	:global(.odd td:last-child) {
		border-top-right-radius: 6px;
		border-bottom-right-radius: 6px;
	}
</style>
